import './styles/main.scss';

jQuery(function($) {
    var $experiencesMenu = $('.experiences-menu.et_pb_fullwidth_menu');
    var $experiencesMenuAll = $('body.page .experiences-menu.et_pb_fullwidth_menu .mobile_menu_bar');
    var $experiencesMenuSpring = $('body.term-spring .experiences-menu.et_pb_fullwidth_menu .mobile_menu_bar');
    var $experiencesMenuSummer = $('body.term-summer .experiences-menu.et_pb_fullwidth_menu .mobile_menu_bar');
    var $experiencesMenuWinter = $('body.term-winter .experiences-menu.et_pb_fullwidth_menu .mobile_menu_bar');
    var $experiencesMenuFall = $('body.term-fall .experiences-menu.et_pb_fullwidth_menu .mobile_menu_bar');
    var $eventsCatMenu = $('body.tax-events .events-menu.et_pb_fullwidth_menu .mobile_menu_bar');
    var $eventsAllMenu = $('.events-menu.et_pb_fullwidth_menu .mobile_menu_bar');
    var $eventsAllLabel = $('#all-events').text();
    var $eventCatLabel = $('body.tax-events #event-category-title').text();
    var $enviraGalleryLink = $('.envira-gallery-links');
    var $status = $('.slick-counter');
    var $slickElement = $('.fagsfacf-slider');
    
    if ( $experiencesMenu.length ) {
        $experiencesMenuAll.attr('data-content', 'all');
        $experiencesMenuSummer.attr('data-content', 'summer');
        $experiencesMenuSpring.attr('data-content', 'spring');
        $experiencesMenuWinter.attr('data-content', 'winter');
        $experiencesMenuFall.attr('data-content', 'fall');
    }

    if ( $eventsAllMenu.length ) {
        $eventsAllMenu.attr('data-content', $eventsAllLabel);
    }

    if ( $eventsCatMenu.length ) {
        $eventsCatMenu.attr('data-content', $eventCatLabel);
    }

    if ( $enviraGalleryLink.length ) {
        $enviraGalleryLink.addClass( "et_pb_button et_pb_button_0 et_pb_bg_layout_dark dp-dfg-image-link entry-thumb-popup" );
    }

    $slickElement.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
        var i = (currentSlide ? currentSlide : 0) + 1;
        $status.text(i + '/' + slick.slideCount);
    });
});
